// @flow
const firebaseConfig = {
  apiKey: "AIzaSyBsjSa54F7S1jiKV9GF0R6IAvha02a8O_U",
  authDomain: "sg-coe.firebaseapp.com",
  databaseURL: "https://sg-coe.firebaseio.com",
  projectId: "sg-coe",
  storageBucket: "sg-coe.appspot.com",
  messagingSenderId: "768105548201",
  appId: "1:768105548201:web:092508110ff81f5b731cb8",
  measurementId: "G-V53VQ183WP",
};

export default firebaseConfig;